import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import s from "./Partners.module.scss";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { useDispatch, useSelector } from "react-redux";
import { getPartnersList } from "../../redux/ApplicationSlice";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const Partners = () => {
  const partners = useSelector((state) => state.application.partners);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPartnersList());
  }, [dispatch]);
  return (
    <div className={s.partners}>
      <h2 className={s.h2}>Наши партнеры</h2>

      <Marquee speed={30} pauseOnHover={true} className={s.marquee}>
        {partners.map((it, index) => (
          <a
            key={index}
            href={it.url}
            target="_blank"
            rel="noopener noreferrer"
            className={s.slide}
          >
            <img
              src={it.partner_logo}
              className={s.img}
              style={{ height: "40px", marginTop: "10px" }}
              alt={it.title}
            />
          </a>
        ))}
      </Marquee>
    </div>
  );
};

export default Partners;
